import React, { useEffect, useState } from 'react';
import AuthService from '../services/authService';

const THEMES = {
  purple: 'bg-purple-700',
  emerald: 'bg-emerald-700',
};

export default function ImpersonationBanner({ theme = 'purple' }) {
  const [impersonator, setImpersonator] = useState(null);

  useEffect(() => {
    setImpersonator(AuthService.getImpersonator());
  }, []);

  if (!impersonator) return null;

  const currentUser = AuthService.getUser();
  const viewingName = currentUser?.superAdmin?.staff?.name || 'this staff member';
  const originalName = impersonator?.superAdmin?.staff?.name || 'your account';

  const handleExit = () => {
    AuthService.stopImpersonation();
    window.location.href = '/admin/staff';
  };

  return (
    <div className={`flex flex-wrap items-center justify-center gap-3 ${THEMES[theme] || THEMES.purple} px-4 py-2 text-sm text-white`}>
      <span>
        Viewing as <strong>{viewingName}</strong> — logged in as {originalName}
      </span>
      <button
        type="button"
        onClick={handleExit}
        className="rounded-md bg-white/20 px-3 py-1 text-xs font-semibold hover:bg-white/30"
      >
        Exit to my account
      </button>
    </div>
  );
}
